export default __webpack_public_path__ + "static/media/review2.a1b902f5.webp";